import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment"; let __URL_API__  = `${environment.URL_API}`; 

@Injectable({providedIn: 'root'})
export class MaintainService {

    constructor(private _http: HttpClient) { }

    async getMaintainInfos(): Promise<string> {
        try {
            let response = await this._http.get(__URL_API__ + 'api/Maintain/GetMaintainInformations').toPromise();
            return response as string;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}